import { gql } from "@apollo/client";

//queries

export const QUERY_LOCKER_TYPE = gql`
	query {
		lockerTypes {
			lockerTypeId
			lockerType
		}
	}
`;

export const QUERY_LOCKER_NAME = gql`
	query ($operatorId: ID!, $selectedLockerType: Int) {
		lockers(operatorId: $operatorId, lockerTypeId: $selectedLockerType) {
			lockerName
			lockerId
		}
	}
`;

export const QUERY_COMPANY_BRANCHES = gql`
	query ($operatorId: ID!, $selectedPartnerCompany: ID) {
		searchBranches(
			operatorId: $operatorId
			partnerId: $selectedPartnerCompany
		) {
			partnerBranchId
			partnerBranch
		}
	}
`;
export const QUERY_COMPANY_NKCNAME = gql`
	query ($operatorId: ID!) {
		partners(operatorId: $operatorId) {
			partnerId
			companyNickname
		}
	}
`;
